import React, { useState } from "react";

type AuthPasswordFieldProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  autoComplete?: string;
  hint?: string;
  required?: boolean;
};

export default function AuthPasswordField({
  label,
  value,
  onChange,
  autoComplete = "current-password",
  hint,
  required,
}: AuthPasswordFieldProps) {
  const [visible, setVisible] = useState(false);

  return (
    <label className="block mb-4">
      <span className="block text-sm font-medium text-slate-700 mb-1.5">
        {label}
      </span>
      <div className="relative">
        <input
          type={visible ? "text" : "password"}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          autoComplete={autoComplete}
          required={required}
          className="w-full border border-slate-300 bg-white px-3 py-2.5 pr-20 text-sm text-slate-800 rounded-sm focus:outline-none focus:ring-2 focus:ring-slate-400 focus:border-slate-400"
        />
        <button
          type="button"
          onClick={() => setVisible((v) => !v)}
          className="absolute right-2 top-1/2 -translate-y-1/2 text-xs font-medium text-slate-600 hover:text-slate-900 px-2 py-1"
          aria-label={visible ? "Hide password" : "Show password"}
        >
          {visible ? "Hide" : "Show"}
        </button>
      </div>
      {hint && <span className="block text-xs text-slate-500 mt-1">{hint}</span>}
    </label>
  );
}
